<template>
  <div class="question-wrapper alert text-dark alert-primary">
    <div class="h5 mb-0">
      Identify the model by selecting the corresponding answer below.
    </div>
  </div>
</template>

<script>
export default {
  name: "InstructionsBlock"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
